// jshint esversion: 8
import ApiFactory from '@/api/ApiFactory';
const StopsApi = ApiFactory.get('stops');

const fetchAll = async ({ commit }, qs) => {
  const { data } = await StopsApi.getAll(qs);
  commit('SET_DATA', data);
  const stopsMap = new Map();
  for (let i = 0; i < data.length; i++) {
    const stop = data[i];
    if (stopsMap.has(stop.trip)) {
      const stops = stopsMap.get(stop.trip);
      stops.push(stop);
      stopsMap.set(stop.trip, stops);
    } else {
      stopsMap.set(stop.trip, [ stop ]);
    }
  }
  commit('SET_STOPS_BY_TRIP_MAP', stopsMap);
};

const clear = ({ commit }) => {
  commit('CLEAR_DATA');
};

export default {
  fetchAll,
  clear
};
